import { companyApis } from '@apis/dashboard/companyApis';
import { useQuery } from '@hooks/useQuery';

export const useK01 = (id: number) => {
  return useQuery([`/dashboard/company/${id}/k01/`], () =>
    companyApis
      .get('/dashboard/company/{id}/k01/', {
        path: { id },
      })
      .then((r) => r['200']!),
  );
};
